import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  isLoggedIn: false,
  user: {},
  dropbox: [],
  prices: [],
  paymentType: {
    po: true,
    cc: true,
    pa: true,
    acgtcard: true,
    grant: false
  },
	userPrimers: [],
	wpsExcludeCorp: false
};

//creates the user slice with the initial state and actions
const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    //action creators
    isLoggedIn(state, action) {
      state.isLoggedIn = action.payload;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    setPaymentType(state, action) {
      state.paymentType = action.payload
    },
    setDropboxLocations(state, action) {
      state.dropbox = action.payload;
    },
    setUserPrices(state, action) {
      state.prices = action.payload;
    },
    setUserPrimers(state, action) {
      state.userPrimers = action.payload;
	},
	setWpsExcludeCorp(state, action) {
		state.wpsExcludeCorp = action.payload;
	},
    logout(state, action) {
      Object.assign(state, initialState);
      // localStorage.removeItem("token");
      return;
    },
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return [];
    });
  },
});

export const { isLoggedIn, setUser, logout, setDropboxLocations, setPaymentType, setUserPrices, setUserPrimers, setWpsExcludeCorp } = usersSlice.actions;
export const userReducer = usersSlice.reducer;
